export default __webpack_public_path__ + "static/media/refresh.926c2118.svg";